import { render, staticRenderFns } from "./AppTextarea.vue?vue&type=template&id=0f144ebc&"
import script from "./AppTextarea.js?vue&type=script&lang=js&"
export * from "./AppTextarea.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports